<template>
    <div class="divMargin">
        <div class="header">
            <p id="hrighttitle">{{$t('TƏSDQ_EDRƏM')}}br>{{$t('Azərsığorta_DSKŞ')}}</p>
            <h1 id="hrightform" class="header-info">{{$t('Sədrin_müşaviri_CQurbanlı')}}</h1>
            <div class="title-bottom">
                <p id="hrighttitle">{{$t('Bakı_şəhəri')}}</p>
                <h1 id="hrightform" class="header-info">{{$t('_2024cü_il')}}</h1>
            </div>
            <p style="font-weight: bold;font-size: 16pt;"> SIĞORTA ÖDƏNİŞİ İLƏ BAĞLI AKT №: {{ item.dispClaimNumber }} </p>
        </div>
        <div class="content">
            <div class="section">
                <p class="section-title">{{$t('1SIĞORTA_MÜQAVLƏSNƏ_AD_MƏLUMATLAR')}}</p>
                <div class="info-row">
                    <p class="info-title">{{$t('11_Sığortaçı')}}</p>
                    <p class="info-value">
                        {{  }}
                    </p>

                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('12_Sığorta_şəhadətnaməsi_')}}</p>
                    <p class="info-value">{{ item.policyNumber }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('13_SŞ_növü')}}</p>
                    <p class="info-value">{{ item.insuranceTypeName }}</p>
                </div>
                <br>
                <div class="info-row">
                    <p class="info-title">1.4 {{$t('Sığortalı')}}:</p>
                    <p class="info-value">{{ item.insuredName }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('15_Sığorta_predmeti')}}</p>
                    <p class="info-value">{{ item.insuredDisplayName }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('16_Sığortanın_başlama_və_bitmə_tarixi')}}</p>
                    <p class="info-value">{{ item.startDateStr + '&nbsp;&nbsp;-&nbsp;&nbsp;' + item.endDateStr }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('17_Sığorta_məbləği')}}</p>
                    <p class="info-value">{{ item.insuranceSum }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">1.8 {{$t('Sığorta_növü')}}:</p>
                    <p class="info-value">{{ item.policyTypeName }}</p>
                </div>
                <br>
                <p class="section-title">{{$t('2SIĞORTA_HADSƏSNƏ_DAR_MƏLUMATLAR')}}</p>
                <div class="info-row">
                    <p class="info-title">{{$t('21_Hadisənin_baş_verdiyi_tarix')}}</p>
                    <p class="info-value">
                        {{ item.accidentDateStr }}
                    </p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('22_Məlumat_vermə_tarixi')}}</p>
                    <p class="info-value">{{ item.callDateStr }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('23_Sığorta_hadisəsinin_baş_verdiyi_ərazi')}}</p>
                    <p class="info-value">{{ item.place }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('24_Hadisədə_zərərvuran_şəxs')}}</p>
                    <p class="info-value">{{ item.injuredName }}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('25_Hadisədə_zərər_çəkənlərin_sayı')}}</p>
                    <p class="info-value">{{ item.vehicleCount }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('26_Zərərçəkən')}}</p>
                    <p class="info-value">{{ item.victimName }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('27_Zərərçəkənin_nömrəsi')}}</p>
                    <p class="info-value">{{ item.victimPhone }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('210_Zərər_vurulmuş_predmetə_dair_məlumat')}}</p>
                    <p class="info-value">{{ item.victimDisplayName }}</p>
                </div>
                <!-- <div class="info-row">
                    <p class="info-title">{{$t('211_Sığorta_hadisəsinin_növü')}}</p>
                    <p class="info-value"> {{ item.damageCategoryName }}
                        <span v-if="item.damageCategoryName === 'Xəsarət'">
                            - {{ item.medDamageTypeName }}
                        </span>
                    </p>
                </div> -->
                <br>
                <div class="info-row">
                    <p class="info-title">{{$t('212_Subroqasiya_tələbinin_mövcudluğuna_dair_məluma')}}</p>
                    <p class="info-value">{{item.subragationStatusName}}</p>
                </div>
                <br>
                <p class="section-title">{{$t('3DƏYMŞ_ZƏRƏR_BARƏDƏ_MƏLUMAT')}}</p>
                <div class="info-row">
                    <p class="info-title">{{$t('31_Zərəri_müəyyən_edən_müəssisə')}}</p>
                    <p class="info-value">{{item.basisPrice}}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('32_Zərərin_müəyyən_edildiyi_tarix')}}</p>
                    <p class="info-value">{{ item.damageDateStr}}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('33_Ümumi_zərər_məbləği')}}</p>
                    <p class="info-value">{{ item.damageSumLetter }}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('34_Zərərçəkənin_zərərdə_payı')}}</p>
                    <p class="info-value">{{item.damagePercentage}}</p>
                </div>
                <br>
                <p class="section-title">{{$t('4SIĞORTA_ÖDƏNŞ')}}</p>
                <div class="info-row">
                    <p class="info-title">{{$t('41_Hesablanmış_sığorta_ödənişi')}}</p>
                    <p class="info-value">{{ item.paymentSumLetter}}</p>
                </div>
                <div class="info-row">
                    <p class="info-title">{{$t('42_Sığorta_ödənişini_alan')}}</p>
                    <p class="info-value">{{ item.paymentReceivedPerson}}</p>
                </div>

                <div class="info-row">
                    <p class="info-title">{{$t('43_Telefon_nömrəsi')}}</p>
                    <p class="info-value">{{ item.paymentReceivedPersonPhone }}</p>
                </div>
            </div>
            <br>
            <p class="section-title">{{$t('5_YEKUN_MÜDDƏALAR')}}</p>
            <p class="content-footer">Sığortalı və ya zərərçəkən üçüncü şəxs təsdiq edir ki, bu sığorta aktı ilə müəyyən
                edilmiş sığorta
                ödənişi sığorta hadisəsi nəticəsində dəymiş zərərin əvəzinin ödənilməsi üçün qətidir.
                <br>
                Sığortalı və ya faydalanan şəxs həmçinin, təsdiq edir ki, mövcud şəhadətnamədə göstərilən risklər üzrə
                mənafelərini digər heç bir sığortaçıda sığortalamamışdır və baş vermiş sığorta hadisəsi nəticəsində
                dəymiş zərərə
                görə heç bir digər ödəniş almır.
            </p>
            <br>
            <div class="info-row">
                <p class="info-title">{{$t('Departament_direktoru_1')}}</p>
                <p class="info-value">{{$t('VKərimov')}}</p>
            </div>
            <div class="info-row">
                <p class="info-title">{{$t('Sığorta_hadisələri_şöbəsinin_müdiri_1')}}</p>
                <p class="info-value">{{$t('Dəyanət_Babayev')}}</p>
            </div>
            <div class="info-row">
                <p class="info-title">{{$t('Mütəxəssisicraçı')}}</p>
                <p class="info-value">{{$t('Nurlanə_Ələkbərova')}}</p>
            </div>
            <div class="info-row">
                <p class="info-title">{{$t('Sığorta_iddialarının_tənzimlənməsi_şöbəsinin_müdir')}}</p>
                <p class="info-value">{{$t('ESofiyev')}}</p>
            </div>






        </div>
        <div class="date">
            <span>Aktın çap tarixi və vaxtı: {{ currentDateTime }}</span>
            <span><strong>{{$t('Tarix_2024cü_il')}}</strong></span>
        </div>
    </div>
</template>



<script>
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            item: this.value,
            currentDateTime: new Date().toLocaleString('tr-TR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }),
        };
    },
    watch: {
        value() {
            this.item = this.value;
        },
    },
};
</script>

<style lang="scss" scoped>
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: black !important;
    /* Set default text color to black */
    text-align: left;
    background-color: #fff;
}

.date {
    width: 90%;
    color: black !important;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 15px;
}
.header-info{
    font-weight: 600;
      font-size: var(--font-medium) !important;
}
.content-footer {
    width: 77.6%;
    margin-left: 25px;
}

.header {
    font-size: 18px;
    text-align: center;
    margin-bottom: 2px;
    color: black;
    /* Set text color to black */
}

.note {
    font-size: smaller;
    /* Daha küçük font boyutu */
    text-align: left;
    /* Metni sola hizala */
    width: 50%;
    /* Veya istediğiniz başka bir genişlik */
    padding: 5px;
    /* İç boşluğu ayarla */
    box-sizing: border-box;
    /* Padding'i genişliğe dahil et */
}


.content {
    font-size: 16px;
    color: black;
    /* Set text color to black */
}

.footer {
    text-align: right;
    margin-top: 2px;
    font-weight: bold;
    color: black;
    /* Set text color to black */
}

.footer>div {
    display: flex;
    justify-content: space-between;
}

.section-title {
    font-weight: 700;
    margin-top: 10px;
    color: black;
    font-size: 14pt;
    /* Set text color to black */
}

#hrighttitle {
    text-align: right;
    font-weight: bold;
    color: black;
    font-size: 15pt;
    /* Set text color to black */
}

#hrightform {
    color: black;
    /* Set text color to black */
    font-size: smaller;
    text-align: right; 
    margin-top: 15px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
}

.info-title,
.info-value {
    width: 50%;
    margin: 0;
}

.info-title {
    text-align: left;
    padding-right: 10px;
    font-size: 15pt;
}

.info-value {
    text-align: left;
    padding-left: 10px;
    font-size: 15pt;
}

@media print {
    .divMargin {
        padding: 5% !important;
    }
}

.divMargin {
    padding: 5%;
}

h4 {
    text-decoration: underline;
    color: black;
    /* Set text color to black */
}

.title-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>